import ProgressBar from "@badrap/bar-of-progress";
import "@livekit/components-styles";
import { SessionProvider } from "next-auth/react";
import Head from "next/head";
import Router, { useRouter } from "next/router";
import { GoogleAnalytics } from "nextjs-google-analytics-gtm";
import "../styles/main.scss";
import Toast from "../components/Toast";
import { Toaster } from "sonner";
import usePreservedSearchParams from "@/lib/hooks/usePreservedSearchParams";
import React from "react";

const progress = new ProgressBar({
  size: 2,
  color: "#2363EB",
  className: "bar-of-progress",
  delay: 100,
});

if (typeof window !== "undefined") {
  progress.start();
  progress.finish();
}

Router.events.on("routeChangeStart", progress.start);
Router.events.on("routeChangeComplete", () => {
  progress.finish();
  window.scrollTo(0, 0);
});
Router.events.on("routeChangeError", progress.finish);

const allowedPaths = [
  "onboarding",
  "bootcamps",
  "fortune-report",
  "vip-notification",
  "masterclasses",
  "contact-us",
];
export default function App({ Component, pageProps }: any) {
  usePreservedSearchParams();
  const router = useRouter();
  const [enableWebengage, setEnableWebengage] = React.useState(false);
  React.useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const pathname = router.asPath;
    const allowedRegexRoutes = allowedPaths.map(
      (path) => new RegExp(`^/${path}(\\/.*)?$`),
    );

    const isAllowed = allowedRegexRoutes.some((regex) => regex.test(pathname));

    if (isAllowed) {
      setEnableWebengage(true);
    }
  }, [router.asPath]);
  return (
    <>
      <Head>
        <GoogleAnalytics />
        <script
          dangerouslySetInnerHTML={{
            __html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '2979881788889024');
fbq('init', '2616390748737186');
fbq('init', '1033588861963547');
fbq('init', '756578293783132');
fbq('track', 'PageView');`,
          }}
        />
        {enableWebengage && (
          <script
            type="text/javascript"
            id="_webengage_script_tag"
            dangerouslySetInnerHTML={{
              __html: `var webengage;!function(e,t,n,i,o){function s(e,t){e[t[t.length-1]]=function(){a.__queue.push([t.join("."),arguments])}}var r,g,a=e[n],c="init options track screen onReady".split(" "),l="feedback survey notification".split(" "),p="options render clear abort".split(" "),u="Open Close Submit Complete View Click".split(" "),f="identify login logout setAttribute".split(" ");if(!a||!a.__v){for(e[n]=a={__queue:[],is_spa:1,__v:"6.0",user:{}},r=0;r<c.length;r++)s(a,[c[r]]);for(r=0;r<l.length;r++){for(a[l[r]]={},g=0;g<p.length;g++)s(a[l[r]],[l[r],p[g]]);for(g=0;g<u.length;g++)s(a[l[r]],[l[r],"on"+u[g]])}for(r=0;r<f.length;r++)s(a.user,["user",f[r]]);setTimeout(function(){var e=t.createElement("script"),n=t.getElementById("_webengage_script_tag");e.type="text/javascript",e.async=!0,e.src=("https:"==t.location?.protocol?"https://widgets.in.webengage.com":"http://widgets.in.webengage.com")+"/js/webengage-min-v-6.0.js",n.parentNode.insertBefore(e,n)})}}(window,document,"webengage"),webengage.init('in~82617217');`,
            }}
          ></script>
        )}
        <script
          id="gtm-script"
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-NCNG8P46')
            `,
          }}
        />

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-QCMP6XGGBD"
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', 'G-QCMP6XGGBD');
            `,
          }}
        />
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-D8HSFBQ8FG"
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', 'G-D8HSFBQ8FG');
            `,
          }}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Fonts */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap"
          rel="stylesheet"
        />
      </Head>
      <Toast />
      <Toaster />
      <SessionProvider>
        <Component {...pageProps} />
      </SessionProvider>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-NCNG8P46"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
    </>
  );
}
